/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Requester_Cannot_ApproveInputs */

const en_error_requester_cannot_approve = /** @type {(inputs: Error_Requester_Cannot_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You asked for this, so someone else approves it.`)
};

/**
* | output |
* | --- |
* | "You asked for this, so someone else approves it." |
*
* @param {Error_Requester_Cannot_ApproveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_requester_cannot_approve = /** @type {((inputs?: Error_Requester_Cannot_ApproveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Requester_Cannot_ApproveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_requester_cannot_approve(inputs)
});